import SpellDamageEffect from './SpellDamageEffect';

export default SpellDamageEffect;
export { SpellDamageEffect };
